import React, { useState, useEffect } from 'react';
import { 
  IconButton, 
  Zoom, 
  Tooltip,
  Box
} from '@mui/material';
import { KeyboardArrowUp } from '@mui/icons-material';

const ArrowUp = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Check scroll position
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <Zoom in={isVisible} timeout={300}>
      <Tooltip title="Scroll to top" arrow placement="left">
        <IconButton
          onClick={scrollToTop}
          sx={{
            position: 'fixed',
            bottom: 30,
            right: 32,
            width: 36,
            height: 36,
            bgcolor: 'primary.main',
            background: 'linear-gradient(135deg, #3b76b2 0%, #32a059 100%)',
            color: 'white',
            '&:hover': {
              bgcolor: 'primary.dark',
              transform: 'scale(1.1)',
              boxShadow: '0 8px 25px rgba(2, 173, 253, 0.4)'
            },
            boxShadow: 4,
            zIndex: 999,
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
          }}
        >
          <KeyboardArrowUp />
        </IconButton>
      </Tooltip>
    </Zoom>
  );
};

export default ArrowUp;